import React, { useRef, useEffect } from "react";
import "./commands.scss";

const commands = [
  {
    command: "/post",
    description: "Send a global message",
    level: "5 Credits (vip free)",
  },
  { command: "/msg", description: "Gold Global Message", level: "5 Credits" },
  {
    command: "/cmd",
    description: "Show all Command inside the game",
    level: "Any",
  },
  {
    command: "/cmdbuyset",
    description: "info buy Sets commands",
    level: "Any",
  },
  {
    command: "/cmdbuywing",
    description: "info buy Wings commands",
    level: "Any",
  },

  {
    command: "/cmdbuyweapon",
    description: "info buy Weapons commands",
    level: "Any",
  },

  {
    command: "/cmdbuyshield",
    description: "info buy Shields commands",
    level: "Any",
  },

  {
    command: "/cmdbuyring",
    description: "info buy Ring And Pendants commands",
    level: "Any",
  },

  { command: "/cmdwedding", description: "info Marry system", level: "Any" },
  { command: "/cmdbtr", description: "Battle Resets Events", level: "Any" },
  { command: "/cmdadd", description: "add points commands", level: "Any" },
  {
    command: "/grandReset",
    description: "Disable",
    level: "Disable",
  },
  { command: "/reset", description: "make Reset", level: "400" },
  { command: "/pk", description: "pk (on/off)", level: "Any" },
  { command: "/buy", description: "buy items", level: "Any" },
  { command: "/buyfull", description: "buy full", level: "10000 Credits" },
  {
    command: "/sendCredits",
    description: "send credits to other user",
    level: "Any",
  },
  { command: "/info", description: "Player information", level: "Any" },
  { command: "/crew", description: "server team connected", level: "Any" },
  {
    command: "/go",
    description: "Teleport to other user",
    level: "200 Credits",
  },
  {
    command: "/eventsInfo",
    description: "info events time in the game",
    level: "Any",
  },

  {
    command: "/reset",
    description: "Reset your character",
    level: "400",
  },

  {
    command: "/vip",
    description: "buy VIP",
    level: "any",
  },

  {
    command: "/kalima6",
    description: "50 Credits",
    level: "280",
  },
  {
    command: "/hotspot",
    description: "10 Credits",
    level: "280",
  },
  {
    command: "/bar",
    description: "teleport to lorencia bar",
    level: "any",
  },
  { command: "/addstr", description: "Add points", level: "Any" },
  { command: "/addene", description: "Add points", level: "Any" },
  { command: "/adddex", description: "Add points", level: "Any" },
  { command: "/addcom", description: "Add points", level: "Any" },
  { command: "/addvit", description: "Add points", level: "Any" },
];

const CommandsTable = () => {
  const scrollTargetRef = useRef(null);

  useEffect(() => {
    const yOffset = -80; // 🔧 תכוון כאן לפי גובה ה-header שלך
    const y =
      scrollTargetRef.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  return (
    <div ref={scrollTargetRef} className="commands-container">
      <h2 className="commands-title">AVAILABLE COMMANDS</h2>
      <table className="commands-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Command</th>
            <th>Description</th>
            <th>Required Level</th>
          </tr>
        </thead>
        <tbody>
          {commands.map((cmd, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{cmd.command}</td>
              <td>{cmd.description}</td>
              <td>{cmd.level}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CommandsTable;
